import { Box, Typography } from "@mui/material";
import { resolveMprcMargin } from "components/styles/resolvers";
import * as React from "react";

interface IProps {
    message: React.ReactNode;
    marginTop?: MprcMargin;
}

export const MprcFilterEmptyDataset: React.FC<IProps> = (
    { marginTop = "none", message }
) => {
    return (
        <Box sx={theme => ({ marginTop: resolveMprcMargin(theme, marginTop) })}>
            <Typography variant="captionHeader">{message}</Typography>
        </Box>
    );
};
